































































































import Translations, { OfferListItem } from '@/services/Translations';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';

@Component({
  name: "About",
  components: {
  },
})
export default class ProjectsSections extends Vue{

      tab =  null;
      selectedFeature: OfferListItem | null =  null;
      caruselIndex =  1;
      overlay = false;
      features: OfferListItem[] = [];

      mounted(){
        Translations.selsectedLanguage$.subscribe(() => {
          this.features = Translations.getMessages().sections.briefOffer.offerList.filter(o => !!o.projectImagesNumbers);
        });
      }

      selectImage( imageIndex: number, item?: OfferListItem ){
          if(!item) return;
          this.selectedFeature = item;
          this.caruselIndex = imageIndex

          this.overlay = true;
      }

      closeOverlay(){
        this.overlay = false;
        this.selectedFeature = null;
      }

}
